<template>

    <div class="bg-alt-yellow p-3 extra-rounded">

        <h1 style="text-shadow: 3px 3px #1d1800; color: white; margin-bottom: 6px;">Order History</h1>

        <div v-if="orders.length > 0">
            
            <div v-for="(order, key) in orders" class="order-row" style="border: 2px solid #1d1800; padding: 8px; margin-bottom: 6px; border-radius: 6px;">

                <div class="flex-x center-x" @click="this.ToggleOrderInfo(key)" style="justify-content: space-between;">
                    <h4 v-text="order.id"></h4>
                    <i v-if="this.active !== key" class="fas fa-plus-square"></i>
                    <i v-if="this.active == key" class="fas fa-minus-square"></i>
                </div>

                <div v-show="this.active == key">
                    <hr>
                    <p v-text="`Date: ${this.Timestamp(order.created_at)}`"></p>
                    <p v-text="`Total: £${order.total}`"></p>
                    <p v-text="`Status: ${order.status}`"></p>
                    <button class="btn btn-warning">
                        <a :href="`/account/order/${ order.id }`">Details</a>
                    </button>
                    <button class="btn btn-warning mx-1">
                        <a target="_blank" :href="`/account/order/invoice/${ order.id }`">Invoice</a>
                    </button>
                </div>

            </div>
        
        </div>

        <div v-else>
            <h4>There's nothing here (yet)</h4>
        </div>

    </div>

</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            active: null,
        }
    },

    props: ['orders'],

    methods: {
        ToggleOrderInfo ( key ) {
            this.active = key == this.active ? this.active = null : this.active = key;
        },

        Timestamp (date) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },
    }

}
</script>